import { render, staticRenderFns } from "./ExpensesDetail.vue?vue&type=template&id=479ea45c&"
import script from "./ExpensesDetail.vue?vue&type=script&lang=js&"
export * from "./ExpensesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports